import React from 'react';
import { appConfigStore } from 'Models/AppConfigStore';
import { stringNotEmpty } from '../../../Util/TypeGuards';
import useDeviceDetect from '../../../Hooks/useDeviceDetect';

const MarketingBanner = () => {
	const { isMobile } = useDeviceDetect();
	const bannerContent = appConfigStore.globalBannerContent;

	if (appConfigStore.globalBannerEnabled && stringNotEmpty(bannerContent) && !isMobile) {
		return (
			<div className="marketing-banner-container">
				{/* eslint-disable-next-line react/no-danger */}
				<div className="wysiwyg-content" dangerouslySetInnerHTML={{ __html: bannerContent }} />
			</div>
		);
	}
	return <></>;
};

export default MarketingBanner;
